import styled from 'styled-components';
import {Space} from 'antd';

const StyledExpensesTab = styled(Space)`
  position: relative;
  width: 100%;

  .grouped-row {
    background-color: ${props => props.theme.colors.neutral_2} !important;
    color: ${props => props.theme.colors.neutral_7};

    td {
      background-color: ${props => props.theme.colors.neutral_2};
    }

    .amount {
      color: ${props => props.theme.colors.neutral_10};
      font-weight: 700;
    }
  }

  .ghost-table-cell {
    .ant-tag {
      margin: 0;
    }
  }
`;

const StyledExpensesTabIcon = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 16px;

  &:hover {
    cursor: pointer;
  }

  svg {
    height: 16px;
    width: 16px;
  }

  .no-receipt {
    svg {
      rect {
        fill: ${props => props.theme.colors.neutral_6};
      }
    }
  }
`;

const StyledExpensesTabActionsSpace = styled(Space)`
  & > .ant-space-item {
    align-items: center;
    display: flex;
  }

  button {
    align-items: center;
    display: flex;
    justify-content: center;
    svg {
      height: 14px;
      width: 14px;
      path {
        fill: ${props => props.theme.colors.neutral_10};
      }
    }
  }
`;

const StyledExpensesTabActionsGhostSpace = styled(Space)`
  min-width: 105px;

  align-items: center;

  & > .ant-space-item {
    display: flex;
  }
`;

export {
  StyledExpensesTab,
  StyledExpensesTabIcon,
  StyledExpensesTabActionsSpace,
  StyledExpensesTabActionsGhostSpace,
}
